export function getWorkStartTime(record) {
  return (
    record?.work_time?.start_time ||
    record?.work_start_time ||
    record?.work?.start_time ||
    record?.expected_work_start_time ||
    null
  );
}

export function getWorkEndTime(record) {
  return (
    record?.work_time?.end_time ||
    record?.work_end_time ||
    record?.work?.end_time ||
    record?.expected_work_end_time ||
    null
  );
}

export function getBreakStartTime(record) {
  return (
    record?.break_time?.start_time ||
    record?.break_start_time ||
    record?.break?.start_time ||
    record?.expected_break_start_time ||
    null
  );
}

export function getBreakEndTime(record) {
  return (
    record?.break_time?.end_time ||
    record?.break_end_time ||
    record?.break?.end_time ||
    record?.expected_break_end_time ||
    null
  );
}

export function formatScheduleTime(time, emptyLabel = "-") {
  return time || emptyLabel;
}

export function formatTimeToHi(time) {
  if (time == null || time === "") return "";

  const value = String(time).trim();
  if (!value) return "";

  const twentyFourHourMatch = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?(?:\.\d+)?$/);
  if (twentyFourHourMatch && !/am|pm/i.test(value)) {
    const hours = String(parseInt(twentyFourHourMatch[1], 10)).padStart(2, "0");
    return `${hours}:${twentyFourHourMatch[2]}`;
  }

  const twelveHourMatch = value.match(
    /^(\d{1,2}):(\d{2})(?::\d{2})?(?:\.\d+)?\s*(AM|PM)$/i
  );
  if (twelveHourMatch) {
    let hours = parseInt(twelveHourMatch[1], 10);
    const minutes = twelveHourMatch[2];
    const meridiem = twelveHourMatch[4].toUpperCase();

    if (meridiem === "PM" && hours !== 12) hours += 12;
    if (meridiem === "AM" && hours === 12) hours = 0;

    return `${String(hours).padStart(2, "0")}:${minutes}`;
  }

  const parsedDate = new Date(`1970-01-01T${value}`);
  if (!Number.isNaN(parsedDate.getTime())) {
    return `${String(parsedDate.getHours()).padStart(2, "0")}:${String(
      parsedDate.getMinutes()
    ).padStart(2, "0")}`;
  }

  return value;
}

export function appendEmployeeScheduleToFormData(formData, employees, indexPrefix = "employees") {
  let index = 0;

  employees.forEach((item) => {
    if (!item.employee?.value || !item.work_start_time || !item.work_end_time) {
      return;
    }

    formData.append(
      `${indexPrefix}[${index}][employee_id]`,
      item.employee.value
    );
    formData.append(
      `${indexPrefix}[${index}][work_start_time]`,
      item.work_start_time
    );
    formData.append(
      `${indexPrefix}[${index}][work_end_time]`,
      item.work_end_time
    );

    if (item.break_start_time) {
      formData.append(
        `${indexPrefix}[${index}][break_start_time]`,
        item.break_start_time
      );
    }

    if (item.break_end_time) {
      formData.append(
        `${indexPrefix}[${index}][break_end_time]`,
        item.break_end_time
      );
    }

    index += 1;
  });
}
